module.exports = __webpack_public_path__ + "static/media/crowdvision.c784ea37.png";